export default {
  path: '/support',
  name: 'support',
  redirect: { name: 'support.privacy' },
  component: () => import(/* webpackChunkName: "support" */ '@/views/Support'),
  children: [
    {
      path: 'privacy',
      name: 'support.privacy',
      meta: { title: 'Tradie Pass | Privacy Policy' },
      component: () =>
        import(/* webpackChunkName: "support" */ '@/views/Support/Privacy')
    },
    {
      path: 'terms',
      name: 'support.terms',
      meta: { title: 'Tradie Pass | Terms and Conditions' },
      component: () =>
        import(/* webpackChunkName: "support" */ '@/views/Support/Terms')
    }
  ]
}
